export const getYearsArray = () => {
    const years = [];
    const currentYear = new Date().getFullYear() + 1;
    const yearsLimit = 50;
    for (let i = 0; i < yearsLimit; i++) {
        years.push(currentYear - i);
    }
    return years;
}

export const filterRecipients = (query, recipientInfo) => {
    var lowerCaseFirstName = recipientInfo.first_name.toLowerCase();
    var lowerCaseMiddleName = recipientInfo.middle_name.toLowerCase();
    var lowerCaseLastName = recipientInfo.last_name.toLowerCase();
    var lowerCaseQuery = query.toLowerCase();

    return `${lowerCaseFirstName} ${lowerCaseMiddleName} ${lowerCaseLastName}`.includes(lowerCaseQuery) ||
        `${lowerCaseFirstName} ${lowerCaseLastName}`.includes(lowerCaseQuery);
}



// WEBPACK FOOTER //
// ./src/helpers/functions.js